const APP_URI = {
  base: '/',
  login: '/login',
  register: '/register',
  home: '/home',
  profile: '/profile',
  editProfile: '/edit-profile',
  dashboard: '/dashboard',
  reports: '/reports',
  employees: '/employees',
  documents: '/documents',
  daysoff: '/daysoff',
  timeoffs: '/timeoffs',
  nonworkingdays: '/timeoffs/nonworkingdays',
  user: '/user',
  panel: '/panel',
  manageEmployees: 'manage-employees/:userId?',
  passwordRecovery: '/password-recover',
  passwordReset: '/password-reset',
  invitationError: '/invalid-invitation',
  setPassword: '/register',
  settings: '/settings',
  roles: '/roles',
};

export { APP_URI };
